import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 18,
  },
  path: {
    fill: '#7df3e1',
  },
});

const LogoIcon = () => {
  const props = useStyles();

  return (
    <svg
      className={props.svg}
      viewBox="0 0 124 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M124 0H0V42H124V0Z" fill="#EE0000" />
      <path
        d="M114.492 19.2776H114.469V23.0544H115.2C115.2 23.0544 115.2 21.5783 115.2 21.5264C115.246 21.5264 115.516 21.5264 115.516 21.5264C115.516 21.5494 116.442 23.0544 116.442 23.0544L117.195 23.0774H117.241C117.241 23.0774 116.263 21.5264 116.217 21.4514C116.729 21.3015 117.023 20.9267 117.023 20.425C117.023 19.7273 116.534 19.3007 115.706 19.3007H114.486V19.2776H114.492ZM115.683 19.8542C116.097 19.8542 116.315 20.056 116.315 20.402C116.315 20.8517 115.976 20.9498 115.683 20.9498C115.683 20.9498 115.217 20.9498 115.171 20.9498C115.171 20.8979 115.171 19.9234 115.171 19.8773C115.223 19.8542 115.683 19.8542 115.683 19.8542ZM112.249 21.2035C112.249 23.2043 113.71 24.6804 115.637 24.6804C117.586 24.6804 119.047 23.1812 119.047 21.2035C119.047 19.2026 117.586 17.7265 115.66 17.7265C113.71 17.7265 112.249 19.2257 112.249 21.2035ZM112.882 21.2035C112.882 19.6005 114.078 18.3781 115.637 18.3781C117.218 18.3781 118.391 19.6005 118.391 21.2035C118.391 22.8295 117.224 24.0519 115.637 24.0519C114.078 24.0519 112.882 22.8295 112.882 21.2035ZM33.6193 10H51.1661V17.1038H47.3416V13.8056H41.0786V18.9547H46.1223V22.7545H41.0786V28.6301H47.3416V25.3031H51.1661V32.43H33.4238V28.6301H35.8105V13.7998H33.6193V10V10ZM66.861 25.2801H70.8121V32.4069H53.6276V28.6071H56.5032V13.7998H53.6276V10H64.7158V13.7998H61.7655V28.6301H66.838V25.2801H66.861V25.2801ZM23.503 10H31.8882V13.7998H29.9386L24.1357 32.43H19.4082L13.3867 13.7998H11V10H20.9955V13.7998H18.6778L22.0422 25.1532H22.0882L25.746 13.7998H23.526V10H23.503ZM83.3669 10H90.9986V13.7998H88.9972V26.3526C88.9972 31.5766 84.0973 32.6779 81.0779 32.6779C76.8853 32.6779 73.009 31 73.009 25.528V13.7998H70.6223V10H80.0082V13.7998H78.2541V25.1763C78.2541 27.3789 79.2548 28.8781 81.5955 28.8781C83.5681 28.8781 85.1555 27.9267 85.1555 25.3781V13.7998H83.3784V10H83.3669ZM110.714 28.6301H113.152V32.43H102.961V28.855H105.008L101.891 24.2018L98.8662 28.855H100.914V32.43H92.2582V28.6301H94.5471L99.5219 20.9036L94.6276 13.7998H92.7528V10H102.236V13.575H100.31L103.306 17.7784L106.038 13.575H104.186V10H113.158V13.7998H110.328L105.549 21.1285L110.714 28.6301Z"
        fill="white"
      />
    </svg>
  );
};

export default LogoIcon;
